import { render, staticRenderFns } from "./InstallIntegration.vue?vue&type=template&id=12c28c81"
import script from "./InstallIntegration.vue?vue&type=script&lang=js"
export * from "./InstallIntegration.vue?vue&type=script&lang=js"
import style0 from "./InstallIntegration.vue?vue&type=style&index=0&id=12c28c81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports